import { useSelector } from 'react-redux'

import { PartnerType } from '../../types/partner'
import { hasAdminRoles, isAdminRole } from '../isAdminRole'
import { Role } from '../roles'

type UseUserTypeRootState = {
  authorization?: {
    roles?: string[]
  }
  userProfile?: {
    userProfile?: {
      roles?: string[]
    }
  }
}

export const useUserType = (): PartnerType => {
  return useSelector((state: UseUserTypeRootState) => {
    const authRoles: string[] = state.authorization?.roles ?? []
    if (authRoles.length > 0) {
      return hasAdminRoles(authRoles as Role[])
        ? PartnerType.Admin
        : PartnerType.User
    }
    return isAdminRole(state.userProfile?.userProfile)
      ? PartnerType.Admin
      : PartnerType.User
  })
}
